module.exports = __webpack_public_path__ + "img/03-thumb.11ba6847.png";